'use strict';

/*global isEmpty*/
/*global services*/

(function ($) {
    var $btn = null;

    var methods = {
        init: function (/*options*/) {
            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('delete-confirmation-init')) {
                    return;
                }

                $this.addClass('delete-confirmation-init');

                $this.on('click', function (e) {
                    methods.open.apply(_this, e);
                    return false;
                });
            });
        },

        open: function () {
            var _this = this;
            $btn = $(this);
            var refItemInUse = $btn.hasClass('delete-confirmation-in-use');
            var inUseLink = '';
            if (refItemInUse)  {
                inUseLink = $btn.data('in-use-link');
            }

            var modal = services.get('modal');
            modal.empty().open({
                title: services.get('translator').trans('DeleteConfirmationTitle'),
                content: '<p>' + (refItemInUse ? services.get('translator').trans('DeleteItemInUseConfirmationMessage').replace('#LINK#', inUseLink) : services.get('translator').trans('DeleteConfirmationMessage')) + '</p>',
                headerClass: 'bg-danger',
                height: 'auto',
                form: true,
                formSubmitBtnClass: 'btn-danger',
                formSubmitBtnTitle: services.get('translator').trans('Delete'),
                formSubmitCallback: function deleteConfirmationClb(e) {
                    methods.confirm.apply(_this, e);
                }
            });
        },

        confirm: function () {
            var modal = services.get('modal');
            modal.close();

            services.get('window').redirectTo($btn.attr('href'));
        }
    };

    $.fn.DeleteConfirmation = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.DeleteConfirmation');
        }
    };

    $.fn.DeleteConfirmation.defaults = {};
})(jQuery);
